export * as QuizSelector from './quiz'

export const displaySearchModalSelector = (state) => state.displaySearchModal
export const selectCampus = (state) => state.campus
export const selectFormRedirect:
  (state: { formRedirect: URL }) => URL = (state) => state.formRedirect
export const selectHiddenFormParams = (state) => state.hiddenFormParams
export const selectLeadID = (state) => state.leadID
export const selectPersona = (state) => state.persona
export const selectProgram = (state) => state.program
export const selectFeatureFlags = (state) => state.featureFlags
